import axios from "axios";

const API = axios.create({
  baseURL:
  process.env.NODE_ENV === "production"
    ? "https://mrgamblers.com/api"
    : "http://localhost:4000/api",

  withCredentials: true,
});

// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["x-auth-token"] = token;
  }
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default API;
